import { Action } from '@ngrx/store';
import { GuideBox } from 'diagram-js/lib/model';



export enum GuidedBoxesActionTypes {
  UPDATE_GUIDE_BOXES = '[Bpmn Process] Update Guided Boxes'
}


export class UpdateGuidedBoxesAction implements Action {
  readonly type = GuidedBoxesActionTypes.UPDATE_GUIDE_BOXES;
  constructor(public payload: { guidedBoxNodeMap: { [nodeId: string]: GuideBox}}) { }
}


export type GuidedBoxesActions =
  UpdateGuidedBoxesAction;
